interface RequestConfig {
  /**
   * Url to the Kivra Core backend API
   */
  kivraCoreOrigin: string;
  /**
   * TODO: Remove this once Sender GW is used in Campaigns
   * Url to the Kampanha backend API
   */
  kampanhaOrigin: string;
  /**
   * Url to the Sender API Gateway
   */
  senderOrigin: string;
}

const requestConfig: RequestConfig = {
  kivraCoreOrigin: "",
  kampanhaOrigin: "",
  senderOrigin: "",
};

export function getRequestConfig<K extends keyof RequestConfig>(
  key: K,
): RequestConfig[K] {
  const value = requestConfig[key];
  console.assert(value, `${key} is missing from the config object`);
  return value;
}

export function updateRequestConfig(values: Partial<RequestConfig>): void {
  Object.assign(requestConfig, values);
}
